import React from 'react';
import PropTypes from 'prop-types';

import AttributeDef, { AttributePresentation } from 'models/configuration/attribute_def';
import EditableCustomAttribute from './custom_attributes/editable_custom_attribute';
import VisibleCustomAttribute from './custom_attributes/visible_custom_attribute';

export function CustomAttribute({ value, def, renderProps, location }) {
  if (def.presentation === AttributePresentation.EDITABLE) {
    return <EditableCustomAttribute def={def} value={value} renderProps={renderProps} />;
  }

  return <VisibleCustomAttribute def={def} value={value} renderProps={renderProps} location={location} />;
}

CustomAttribute.propTypes = {
  value: PropTypes.string,
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  renderProps: PropTypes.object,
  location: PropTypes.shape({
    type: PropTypes.string,
    subType: PropTypes.string,
  }),
};

export default CustomAttribute;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attribute.jsx